import React, { useState } from 'react';
import axios from 'axios';
import { IconCheck } from './Icons';

const API_BASE_URL = window.location.hostname === 'localhost'
  ? 'http://localhost:5000'
  : window.location.origin;

function ContactFormModal({ isOpen, onClose }) {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(''); // '', 'loading', 'success', 'error'
  const [errorMessage, setErrorMessage] = useState('');

  if (!isOpen) return null;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setErrorMessage('');

    try {
      const response = await axios.post(`${API_BASE_URL}/api/contact`, {
        name: formData.name,
        email: formData.email,
        message: formData.message
      });

      if (response.data.success) {
        setStatus('success');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => {
          onClose();
          setStatus('');
        }, 2500);
      } else {
        setStatus('error');
        setErrorMessage(response.data.error || 'Ошибка отправки. Попробуйте позже.');
      }
    } catch (err) {
      setStatus('error');
      setErrorMessage(err.response?.data?.error || 'Ошибка отправки. Попробуйте позже.');
    }
  };

  return (
    <div className="contact-form-overlay" onClick={onClose}>
      <div className="contact-form-modal" onClick={e => e.stopPropagation()}>
        <button className="contact-form-close" onClick={onClose} aria-label="Закрыть">&times;</button>

        {status === 'success' ? (
          <div className="contact-form-success">
            <div className="contact-form-success-icon"><IconCheck size={32} /></div>
            <h3>Сообщение отправлено!</h3>
            <p>Подтверждение придёт на ваш email. Мы свяжемся с вами в ближайшее время</p>
          </div>
        ) : (
          <>
            <h3 className="contact-form-title">Напишите нам</h3>
            <p className="contact-form-subtitle">
              Оставьте заявку — мы ответим вам на указанный email в ближайшее время
            </p>

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="contact-form-field">
                <label>Ваше имя</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Иван Иванов"
                  required
                  maxLength={100}
                />
              </div>

              <div className="contact-form-field">
                <label>Email для ответа</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="ivan@example.com"
                  required
                  maxLength={200}
                />
              </div>

              <div className="contact-form-field">
                <label>Сообщение</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Расскажите о вашей задаче или задайте вопрос..."
                  rows={4}
                  required
                  maxLength={2000}
                />
              </div>

              {status === 'error' && (
                <div className="contact-form-error">{errorMessage}</div>
              )}

              <button
                type="submit"
                className="contact-form-submit"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? 'Отправка...' : 'Отправить'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default ContactFormModal;
